import { useEffect, useState } from 'react';
import { Get } from '../helpers/AxiosHelper';
import {
  Block,
  Button,
  List,
  ListItem,
  MenuList,
  MenuListItem,
  Navbar,
  Page,
  Preloader,
  Sheet,
  Toolbar,
} from 'konsta/react';
import TabBar from '../components/TabBar';
import { useAppContext } from '../context/AppContext';
import { formatMinerUSD, formatUSD } from '../utils';
import { BsGpuCard } from 'react-icons/bs';
import { MdOutlineQuestionMark, MdOutlineStorefront } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { PiHandWithdraw } from 'react-icons/pi';
import { LuTrophy } from 'react-icons/lu';
import {
  hapticFeedback,
  openLink,
  openTelegramLink,
  shareURL,
} from '@telegram-apps/sdk';
import Lottie from 'lottie-react';
import { FaBookReader } from 'react-icons/fa';

import lottieReward from '../lotties/GIFT-fJ4Ou.json';
import lottieLoading2 from '../lotties/Sending-3DWe6.json';
import lottieDollarSign from '../lotties/Dollar with flag_4-g21g4.json';
import lottieTelegram from '../lotties/Telegram.json';
import { mixTrack } from '../helpers/MixPanelHelper';

function getGreeting(username: string): string {
  const hour = new Date().getHours();

  let greeting: string;

  if (hour >= 5 && hour < 12) {
    greeting = 'Good morning';
  } else if (hour >= 12 && hour < 18) {
    greeting = 'Good afternoon';
  } else {
    greeting = 'Good evening';
  }

  return `${greeting}, ${username}`;
}

const Home = () => {
  const navigate = useNavigate();
  const {
    bundle,
    balance,
    minersBalance,
    referralsBalance,
    isLoading,
    tgUser,
  } = useAppContext();
  const [sheetOpened, setSheetOpened] = useState(false);
  const [claimSheetOpened, setClaimSheetOpened] = useState(false);

  useEffect(() => {}, [balance, bundle, isLoading]);

  if (isLoading) {
    return (
      <Page>
        <div className="flex flex-col justify-center items-center h-full">
          <Lottie animationData={lottieLoading2} className="w-56 h-56" />
        </div>
      </Page>
    );
  }

  return (
    <Page className="select-none pb-40">
      <Block>
        {/* <img src="logo.png" className="w-10 mb-4"/> */}
        <div className="flex justify-between">
          <div>
            {tgUser && (
              <span className="text-xs">{getGreeting(tgUser?.username)}</span>
            )}
            <h2 className="text-3xl mt-3">Dashboard</h2>
          </div>
          <div>
            {tgUser?.photoUrl && (
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}/proxy-image?url=${encodeURIComponent(tgUser?.photoUrl)}`}
                className="w-14 h-14 rounded-full overflow-hidden cursor-pointer"
                onClick={() => navigate('/profile')}
              />
            )}

            {!tgUser?.photoUrl && (
              <div
                onClick={() => navigate('/profile')}
                className="w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-r from-teal-300 to-teal-400 text-white text-xl font-bold"
              >
                {tgUser?.username.substring(0, 2).toUpperCase()}
              </div>
            )}
          </div>
        </div>
      </Block>
      <Block
        onClick={() => {
          mixTrack('[View] Balance Breakdown');
          setSheetOpened(true);
          if (hapticFeedback.impactOccurred.isAvailable()) {
            hapticFeedback.impactOccurred('medium');
          }
        }}
        className="cursor-pointer "
      >
        <div className="flex rounded-xl bg-white p-3">
          <div>
            <h1 className="text-sm flex items-center text-black">
              Your Balance{' '}
              <Lottie
                animationData={lottieDollarSign}
                renderer="svg"
                className="w-10 h-10"
              />
            </h1>
            <h1 className="text-4xl currency text-black tracking-widest">
              {balance > -1 ? formatMinerUSD(balance) : '-'}
            </h1>
          </div>
        </div>
      </Block>

      <MenuList>
        {false && bundle?.canClaimDailyReward && (
          <div
            className="flex justify-between items-center rounded-full bg-md-dark-surface-2 mx-4 mb-1 p-3 cursor-pointer"
            onClick={() => navigate('/my-miners')}
          >
            <div className="flex items-center">
              <Lottie animationData={lottieReward} className="w-8 h-8 mr-2" />
              <span className="text-yellow-500">Claim Daily Reward</span>
            </div>

            <div>
              <Preloader
                size="w-5 h-5"
                colors={{ iconMaterial: 'text-yellow-500' }}
              />
            </div>
          </div>
        )}

        <MenuListItem
          title="My Miners"
          media={<BsGpuCard className="w-5 h-5" />}
          className=""
          onClick={() => {
            mixTrack('[View] My Miners');
            navigate('/my-miners');
          }}
        />

        <MenuListItem
          title="Marketplace"
          media={<MdOutlineStorefront className="w-5 h-5" />}
          className=""
          onClick={() => {
            mixTrack('[View] Marketplace');
            navigate('/store');
          }}
        />

        <MenuListItem
          title="Withdraw"
          media={<PiHandWithdraw className="w-5 h-5" />}
          className=""
          onClick={() => {
            mixTrack('[View] Withdraw');
            navigate('/withdraw');
          }}
        />

        <MenuListItem
          title="Top Miners"
          media={<LuTrophy className="w-5 h-5" />}
          className=""
          onClick={() => {
            mixTrack('[View] Top Miners');
            navigate('/top-miners');
          }}
        />

        <MenuListItem
          title="How does MYNR work?"
          media={<FaBookReader className="w-5 h-5" />}
          className=""
          onClick={() => {
            mixTrack('[View] How');
            navigate('/how');
          }}
        />

        {openTelegramLink.isAvailable() && (
          <MenuListItem
            title="FAQ"
            media={<MdOutlineQuestionMark className="w-5 h-5" />}
            className=""
            onClick={() => {
              mixTrack('[View] FAQ');
              openTelegramLink('https://t.me/MynrNet/49');
            }}
          />
        )}
      </MenuList>

      <div className="flex justify-center">
        <Lottie
          animationData={lottieTelegram}
          className="w-20 h-20 cursor-pointer"
          onClick={() => {
            if (openTelegramLink.isAvailable()) {
              mixTrack('[Click] Open Official Channel');
              openTelegramLink('https://t.me/MynrNet');
            }
          }}
        />
      </div>

      <Sheet
        className="pb-safe w-full"
        opened={claimSheetOpened}
        onBackdropClick={() => setClaimSheetOpened(false)}
      >
        <div className="flex justify-center"></div>
      </Sheet>

      <Sheet
        className="pb-safe w-full"
        opened={sheetOpened}
        onBackdropClick={() => setSheetOpened(false)}
      >
        <Toolbar top>
          <div className="left">Balance breakdown</div>
        </Toolbar>
        <Block>
          <List>
            <ListItem
              title="Miner earnings"
              after={
                <span className="currency text-primary tracking-widest">
                  {formatUSD(minersBalance, 6)}
                </span>
              }
            />
            <ListItem
              title="Referral earnings"
              after={
                <span className="currency text-primary tracking-widest">
                  {formatUSD(referralsBalance, 6)}
                </span>
              }
            />
          </List>
        </Block>
      </Sheet>

      <TabBar selectedTab="home" />
    </Page>
  );
};

export default Home;
